import React from "react";
import { Link } from "react-router-dom";
import { FaSpotify, FaApple, FaYoutube, FaInstagram, FaFacebook } from "react-icons/fa";
import { TID } from "@/constants/testIds";
import Newsletter from "@/components/Newsletter";

export const STREAMING = {
  spotify: "https://open.spotify.com/artist/3CVKryef8hUWE97XMj2cw1",
  apple: "https://music.apple.com/in/artist/kashix/1863480969",
  youtube: "https://youtube.com/@kashix030",
  instagram: "https://www.instagram.com/kashix_official",
  facebook: "https://www.facebook.com/share/19ET9x2txV/",
};

const Footer = () => (
  <footer className="relative mt-32 overflow-hidden border-t border-white/5">
    <div className="absolute inset-0 opacity-20 pointer-events-none"
         style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1550053808-52a75a05955d?w=1600&q=80")', backgroundSize: 'cover', mixBlendMode: 'overlay' }} />
    <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 py-20 grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <div className="font-display text-3xl tracking-[0.35em] text-white">KASHiX</div>
        <div className="mt-3 font-hindi text-lg text-[#FF9933]">आस्था से अनंत तक</div>
        <p className="mt-2 text-xs uppercase tracking-[0.3em] text-white/50">Experience Where Devotion Becomes Power</p>
        <p className="mt-6 max-w-md text-sm text-white/60 leading-relaxed">
          Independent Indian artist producing original devotional music — Sanskrit chants, cinematic bhajans, and aggressive bhakti engineered for the modern era.
        </p>
        <div className="mt-8 flex items-center gap-5">
          {[
            [TID.socialSpotify, STREAMING.spotify, FaSpotify, "Spotify"],
            [TID.socialApple, STREAMING.apple, FaApple, "Apple Music"],
            [TID.socialYoutube, STREAMING.youtube, FaYoutube, "YouTube"],
            [TID.socialInstagram, STREAMING.instagram, FaInstagram, "Instagram"],
            [TID.socialFacebook, STREAMING.facebook, FaFacebook, "Facebook"],
          ].map(([tid, href, Icon, label]) => (
            <a key={label} data-testid={tid} href={href} target="_blank" rel="noreferrer noopener" aria-label={label}
               className="w-11 h-11 flex items-center justify-center rounded-full border border-white/10 hover:border-[#FF9933] hover:text-[#FF9933] transition-all">
              <Icon size={18} />
            </a>
          ))}
        </div>
      </div>

      <div className="lg:col-span-2">
        <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF9933] mb-6">Music</div>
        <ul className="space-y-3 text-sm text-white/70">
          <li><Link to="/releases" className="hover:text-white">All Releases</Link></li>
          <li><Link to="/releases?c=trending" className="hover:text-white">Trending</Link></li>
          <li><Link to="/releases?c=hanuman" className="hover:text-white">Hanuman</Link></li>
          <li><Link to="/releases?c=shiva" className="hover:text-white">Shiva</Link></li>
          <li><Link to="/releases?c=workout" className="hover:text-white">Workout Bhakti</Link></li>
          <li><Link to="/releases?c=meditation" className="hover:text-white">Meditation</Link></li>
        </ul>
      </div>

      <div className="lg:col-span-2">
        <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF9933] mb-6">Navigate</div>
        <ul className="space-y-3 text-sm text-white/70">
          <li><Link to="/lyrics" className="hover:text-white">Lyrics Library</Link></li>
          <li><Link to="/about" className="hover:text-white">About</Link></li>
          <li><Link to="/press" className="hover:text-white">Press</Link></li>
          <li><Link to="/licensing" className="hover:text-white">Licensing</Link></li>
          <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          <li><Link to="/support" className="hover:text-white">Support</Link></li>
        </ul>
        <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF9933] mt-8 mb-4">Festivals</div>
        <ul className="space-y-2 text-sm text-white/70">
          <li><Link to="/festivals/hanuman-jayanti" className="hover:text-white">Hanuman Jayanti</Link></li>
          <li><Link to="/festivals/mahashivratri" className="hover:text-white">Mahashivratri</Link></li>
          <li><Link to="/festivals/ram-navami" className="hover:text-white">Ram Navami</Link></li>
          <li><Link to="/festivals/navratri" className="hover:text-white">Navratri</Link></li>
          <li><Link to="/festivals/diwali" className="hover:text-white">Diwali</Link></li>
        </ul>
      </div>

      <div className="lg:col-span-4">
        <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF9933] mb-6">Enter the temple</div>
        <p className="text-sm text-white/60 mb-5">
          Join the inner circle. First access to unreleased chants and licensing packs.
        </p>
        <Newsletter />
      </div>
    </div>
    <div className="relative border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] uppercase tracking-[0.28em] text-white/40">
        <div>© {new Date().getFullYear()} KASHiX. Created with Devotion. Shared with the World.</div>
        <div className="font-hindi normal-case tracking-normal text-white/50 text-sm">ॐ नमः शिवाय</div>
        <div className="flex items-center gap-4">
          <Link to="/admin" className="hover:text-white/70">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
